// src/lib/apiClient.js
// Safe runtime access to build-time env + smart mock fallback.
// Exports: get(path) -> JSON or throws after all fallbacks fail.

const getRuntimeApiBase = () => {
  // safe checks so browser doesn't throw
  if (typeof window !== 'undefined' && window?.ENV?.API_BASE_URL) return window.ENV.API_BASE_URL;
  if (typeof process !== 'undefined' && process?.env?.REACT_APP_API_BASE_URL) return process.env.REACT_APP_API_BASE_URL;
  return '';
};

const API_BASE = getRuntimeApiBase();

async function get(urlPath) {
  const normalizedUrlPath = String(urlPath || '').replace(/^\/+/, ''); // "api/pitching/overview"
  const direct = (API_BASE ? (API_BASE.replace(/\/$/, '') + '/' + normalizedUrlPath) : '/' + normalizedUrlPath);

  // try main endpoint first
  try {
    const r = await fetch(direct, { credentials: 'include' });
    if (r.ok) return await r.json();
    // fall through to mock attempts
  } catch (err) {
    // fall through to mock attempts
  }

  // candidate mock paths (in order)
  const baseName = normalizedUrlPath.split('/').pop();            // "overview"
  const twoPart = normalizedUrlPath.split('/').slice(-2).join('-'); // "pitching-overview" or "api-pitching"
  const dashed = normalizedUrlPath.replace(/\//g, '-');           // "api-pitching-overview"
  const candidates = [
    `/mock/${normalizedUrlPath}.json`,       // /mock/api/pitching/overview.json
    `/mock/${twoPart}.json`,                 // /mock/pitching-overview.json
    `/mock/${baseName}.json`,                // /mock/overview.json
    `/mock/${dashed}.json`,                  // /mock/api-pitching-overview.json
    `/mock_data/${twoPart}.json`,            // /mock_data/pitching-overview.json
    `/mock_data/${baseName}.json`            // /mock_data/overview.json
  ];

  for (const c of candidates) {
    try {
      const r2 = await fetch(c);
      if (r2.ok) return await r2.json();
    } catch (e) {/* try next */}
  }

  // if nothing found, throw a helpful error
  throw new Error(`apiClient: no data at ${direct} and no mock found (${candidates.join(',')})` );
}

export default { get };
